/* custom-loading
==================================================== */
const customLoading = document.querySelector(".custom-loading");

window.addEventListener(
  "load",
  () => {
    customLoading.classList.add("is-hidden");
  },
  false
);

/* 画像のスクロールアニメーション（ズームアウト）
==================================================== */
const scrollAnimationImage = document.querySelectorAll(".scroll-animation-image");
scrollAnimationImage.forEach((image) => {
  gsap.from(image, 1.5, {
    scrollTrigger: {
      trigger: image,
      start: "top bottom",
    },
    delay: 0.2,
    scale: 1.15,
    opacity: 0.1,
    ease: Power1.easeOut,
  });
});

/* header / CTA
==================================================== */
/* variables */
/* body */
const html = document.querySelector("html");
const body = document.querySelector("body");
const htmlBodyFixedClass = "is-hamburger-open";
//custom header (global)
const customHeader = document.querySelector(".sticky-header");
const customHeaderContent = document.querySelector(".sticky-header .custom-header-content");
const customHamburgerButton = document.querySelector(".sticky-header .custom-header__hamburger");
const customHeaderOverlay = document.querySelector(".sticky-header .custom-header__overlay");
//index header
const indexFv = document.querySelector(".index-fv");
const indexHeader = document.querySelector(".index-fv-header");
const indexHamburgerButton = document.querySelector(".index-fv-header .custom-header__hamburger");
const indexHeaderOverlay = document.querySelector(".index-fv-header .custom-header__overlay");
//classes
const headerShowClass = "is-show";
const hamburgerActiveClass = "is-active";
const indexHeaderHiddenClass = "is-hidden";

/* scroll event */
function scrollHeaderAnimation() {
  let scrollPosition = 0;
  window.addEventListener("scroll", function () {
    let scroll = document.documentElement.scrollTop || document.body.scrollTop;
    const scrollBouncingPosition = window.pageYOffset;
    //上にスクロールしている時
    if ((scrollBouncingPosition <= 0 || scroll - scrollPosition < 1) && !isFvIntersecting) {
      showHeader();
    } else {
      hideHeader();
    }
    scrollPosition = scroll;
  });
}

/* FV is show */
let fvObserver = new IntersectionObserver(fvCallback);
// fvが存在する場合のみ作動
if (indexFv) {
  fvObserver.observe(indexFv);
}
// FVが見えているかの状態管理用変数
let isFvIntersecting = false;

function fvCallback(entries) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // FVが見えている時
      hideHeader();
      isFvIntersecting = true;
    } else {
      // FVが見えていない時
      showHeader();
      isFvIntersecting = false;
    }
  });
}
/*  SP */
document.addEventListener(
  "DOMContentLoaded",
  function () {
    const mq = window.matchMedia("(max-width: 989px)");
    function mqCheck(mq) {
      if (mq.matches) {
        scrollHeaderAnimation();
      }
    }
    mqCheck(mq);
    mq.addEventListener("change", mqCheck, false);
  },
  false
);

/* custom header show and hide function */
const hideHeader = function () {
  customHeader.classList.remove(headerShowClass);
};

const showHeader = function () {
  customHeader.classList.add(headerShowClass);
};

const fixBodyHtml = function () {
  body.classList.add(htmlBodyFixedClass);
  html.classList.add(htmlBodyFixedClass);
};

const unFixBodyHtml = function () {
  body.classList.remove(htmlBodyFixedClass);
  html.classList.remove(htmlBodyFixedClass);
};

/* custom header hamburger */
const hamburgerClickAction = function () {
  let hamburgerOpenStatus = false;
  customHamburgerButton.addEventListener("click", function () {
    if (hamburgerOpenStatus === false) {
      customHeader.classList.add(hamburgerActiveClass);
      fixBodyHtml();
      hamburgerOpenStatus = true;
    } else {
      customHeader.classList.remove(hamburgerActiveClass);
      unFixBodyHtml();
      hamburgerOpenStatus = false;
    }
  });
  customHeaderOverlay.addEventListener("click", function () {
    customHeader.classList.remove(hamburgerActiveClass);
    unFixBodyHtml();
    hamburgerOpenStatus = false;
  });
};
hamburgerClickAction();

/*  header for fv */
function indexHamburgerClickAction() {
  let hamburgerOpenStatus = false;
  indexHamburgerButton?.addEventListener("click", function () {
    if (hamburgerOpenStatus === false) {
      indexHeader.classList.add(hamburgerActiveClass);
      fixBodyHtml();
      hamburgerOpenStatus = true;
    } else {
      indexHeader.classList.remove(hamburgerActiveClass);
      unFixBodyHtml();
      hamburgerOpenStatus = false;
    }
  });
  indexHeaderOverlay?.addEventListener("click", function () {
    indexHeader.classList.remove(hamburgerActiveClass);
    unFixBodyHtml();
    hamburgerOpenStatus = false;
  });
}
indexHamburgerClickAction();
